import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { ManagementTokensEffects } from './management.effects';
import { ManagementTokensReducer } from './management.reducer';

export const provideManagementTokensStore = () => [
  provideState('management', ManagementTokensReducer),
  provideEffects([ManagementTokensEffects]),
];
